// Lightweight client event tracker (fire-and-forget). Never throws.
import axios from "axios";
import { API } from "./api";

const ANON_KEY = "moodcard.anon_id";

function getAnonId() {
    try {
        let id = localStorage.getItem(ANON_KEY);
        if (!id) {
            id = "anon_" + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
            localStorage.setItem(ANON_KEY, id);
        }
        return id;
    } catch { return null; }
}

export function track(name, props) {
    try {
        axios.post(`${API}/events`, { name, props: props || {}, anon_id: getAnonId() },
            { withCredentials: true }).catch(() => {});
    } catch { /* ignore */ }
}
